import React from "react";

const BULLET = /^\s*(?:[-•●▪▶✓✔➢➤►*]|\d+[.)])\s+/;

function blocks(text) {
  const norm = text.replace(/\r/g, "").replace(/\s+([•●▪➢➤►✔✓])\s*/g, "\n$1 ").replace(/([.!?])\s+(?=[A-ZÀ-Ý][^.!?]{0,40}:\s)/g, "$1\n");
  const out = [];
  for (const raw of norm.split(/\n+/)) {
    const line = raw.trim();
    if (!line) continue;
    if (BULLET.test(line)) {
      const last = out[out.length - 1];
      const item = line.replace(BULLET, "");
      if (last?.type === "ul") last.items.push(item); else out.push({ type: "ul", items: [item] });
    } else if (/^#{1,6}\s/.test(line) || (line.length < 60 && /:$/.test(line))) out.push({ type: "h", text: line.replace(/^#+\s*/, "").replace(/:$/, "") });
    else out.push({ type: "p", text: line });
  }
  return out;
}

function Inline({ text }) {
  const m = text.match(/^([^:]{2,40}):\s(.+)$/);
  return m ? <><b className="font-semibold">{m[1]} :</b> {m[2]}</> : text;
}

export function RichSummary({ text }) {
  return (
    <div className="space-y-2 text-sm leading-relaxed text-foreground/90" translate="no" data-testid="candidate-summary">
      {blocks(text).map((b, i) => b.type === "ul" ? (
        <ul key={i} className="list-disc pl-5 space-y-1 marker:text-primary">{b.items.map((x, j) => <li key={j}><Inline text={x} /></li>)}</ul>
      ) : b.type === "h" ? <div key={i} className="text-xs font-semibold uppercase tracking-wide text-muted-foreground pt-1">{b.text}</div>
        : <p key={i}><Inline text={b.text} /></p>)}
    </div>
  );
}
